import { InjectionToken } from "@angular/core";

export const ADAPT_DIALOG_DATA = new InjectionToken("ADAPT_DIALOG_INPUT");
